var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69 42H15V48H69V42Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78 57C71.3825 57 66 51.6175 66 45C66 38.3825 71.3825 33 78 33C84.6175 33 90 38.3825 90 45C90 51.6175 84.6175 57 78 57ZM78 39C74.6925 39 72 41.6925 72 45C72 48.3075 74.6925 51 78 51C81.3075 51 84 48.3075 84 45C84 41.6925 81.3075 39 78 39Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105 42H87V48H105V42Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105 72H51V78H105V72Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42 87C35.3825 87 30 81.6175 30 75C30 68.3825 35.3825 63 42 63C48.6175 63 54 68.3825 54 75C54 81.6175 48.6175 87 42 87ZM42 69C38.6925 69 36 71.6925 36 75C36 78.3075 38.6925 81 42 81C45.3075 81 48 78.3075 48 75C48 71.6925 45.3075 69 42 69Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33 72H15V78H33V72Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.6a554f4f.svg";
export { ForwardRef as ReactComponent };